import { SHADOW_OPTIONS } from '../../../shared/boxes/shadowStyles';

/**
 * Ombre portée d'une box, sur l'échelle partagée (`shared/boxes/shadowStyles`).
 *
 * Le bouton la porte depuis le chantier Boutons ; les box qui ont déjà un fond
 * et des bordures la portent aussi, sans quoi le même effet aurait fini écrit
 * une fois par bloc, avec des valeurs voisines mais différentes.
 */
export const puckShadowField = (label = 'Ombre portée') => ({
  type: 'select',
  label,
  options: SHADOW_OPTIONS.map(({ value, label: optionLabel }) => ({
    value, label: optionLabel,
  })),
});

export default puckShadowField;
